const translations = {
    en: {
        welcomeTitle: 'Homepage - Manage Your Servers With Complete Ease',
        welcomeCompany: 'ABOHAPPY for Technical Solutions and Technology',
        welcomeSubtitle: 'An integrated platform for server and technical resource management. Register now and get access from the administrator.',
        startNow: 'Start Now',
        login: 'Login',
        register: 'Register',
        accountPending: 'Your account is pending approval from the administrator.',
        backToHome: 'Back to Homepage',
        registerSuccess: 'Registration successful! Please wait for admin approval.',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        fullName: 'Full Name',
        logout: 'Logout',
        dashboard: 'Dashboard',
        servers: 'Servers',
        admin: 'Admin',
        summary: 'Summary',
        pendingUsers: 'Pending Users',
        activeUsers: 'Active Users',
        allServers: 'All Servers',
        addServer: 'Add Server',
        serverName: 'Server Name',
        connectionType: 'Connection Type',
        ipPort: 'IP & Port',
        url: 'URL',
        ipAddress: 'IP Address',
        port: 'Port',
        status: 'Status',
        online: 'Online',
        offline: 'Offline',
        cpu: 'CPU',
        ram: 'RAM',
        actions: 'Actions',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        cancel: 'Cancel',
        approve: 'Approve',
        reject: 'Reject',
        role: 'Role',
        user: 'User',
        administrator: 'Administrator',
        changePassword: 'Change Password',
        newPassword: 'New Password',
        confirmDeleteUser: 'Are you sure you want to delete this user?',
        confirmDeleteServer: 'Are you sure you want to delete this server?',
        accessDenied: 'Access Denied',
        loginError: 'Invalid email or password',
        registerError: 'Registration failed',
        serverError: 'Server error',
        loading: 'Loading...',
        noServers: 'No servers available',
        noUsers: 'No users available',
        editLayout: 'Edit Layout',
        saveLayout: 'Save Layout',
        addWidget: 'Add Widget',
        widgetTitle: 'Widget Title',
        widgetUrl: 'Widget URL',
        content: 'Content',
        widgetDescription: 'Description',
        widgetType: 'Type',
        youtube: 'YouTube Video',
        spotify: 'Spotify Player',
        app: 'App Link',
        container: 'Container',
        image: 'Image',
        text: 'Text Content',
        clock: 'Digital Clock',
        calendar: 'Calendar',
        stats: 'Statistics',
        weather: 'Weather',
        news: 'News Feed',
        notifications: 'Notifications',
        lightTheme: 'Light Theme',
        darkTheme: 'Dark Theme',
        toggleTheme: 'Toggle Theme',
        customization: 'Customization',
        backgroundColor: 'Background Color',
        iconSize: 'Icon Size',
        layoutMode: 'Layout Mode',
        widgets: 'Widgets',
        users: 'Users',
        summaryDashboard: 'Summary',
        adminDashboard: 'Admin Dashboard',
        widgetsPageSubtitle: 'Browse and open widgets from your dashboard.',
        usersPageSubtitle: 'Review registered users and account statuses.',
        dragResizeHint: 'Drag and resize widgets while edit mode is enabled.',
        noDescription: 'No description available.',
        openWidget: 'Open Widget',
        createdAt: 'Created At',
        noWidgets: 'No widgets available.',
        editMenu: 'Edit Menu',
        saveMenu: 'Save Menu',
        addMenuItem: 'Add Menu Item',
        editMenuItem: 'Edit Menu Item',
        label: 'Label',
        enterLabel: 'Enter label',
        addSection: 'Add Section',
        editSection: 'Edit Section',
        sectionType: 'Section Type',
        enterContent: 'Enter content',
        enterTitle: 'Enter title',
        enterDescription: 'Enter description',
        editWidget: 'Edit Widget',
        confirmDelete: 'Are you sure you want to delete this item?',
        addItem: 'Add Item',
        itemType: 'Item Type',
        addTo: 'Add to',
        sections: 'Sections',
        icons: 'Icons',
        editItem: 'Edit Item'
    },
    ar: {
        welcomeTitle: 'الصفحة الرئيسية - إدارة خوادمك بكل سهولة',
        welcomeCompany: 'أبو هابي للحلول التقنية والتكنولوجيا',
        welcomeSubtitle: 'منصة متكاملة لإدارة الخوادم والموارد التقنية. سجل الآن واحصل على الوصول من المشرف.',
        startNow: 'ابدأ الآن',
        login: 'تسجيل الدخول',
        register: 'التسجيل',
        accountPending: 'حسابك في انتظار موافقة المشرف.',
        backToHome: 'العودة إلى الصفحة الرئيسية',
        registerSuccess: 'تم التسجيل بنجاح! يرجى انتظار موافقة المشرف.',
        email: 'البريد الإلكتروني',
        password: 'كلمة المرور',
        confirmPassword: 'تأكيد كلمة المرور',
        fullName: 'الاسم الكامل',
        logout: 'تسجيل الخروج',
        dashboard: 'لوحة التحكم',
        servers: 'الخوادم',
        admin: 'المشرف',
        summary: 'الملخص',
        pendingUsers: 'المستخدمون المعلقون',
        activeUsers: 'المستخدمون النشطون',
        allServers: 'جميع الخوادم',
        addServer: 'إضافة خادم',
        serverName: 'اسم الخادم',
        connectionType: 'نوع الاتصال',
        ipPort: 'IP والمنفذ',
        url: 'الرابط',
        ipAddress: 'عنوان IP',
        port: 'المنفذ',
        status: 'الحالة',
        online: 'متصل',
        offline: 'غير متصل',
        cpu: 'المعالج',
        ram: 'الذاكرة',
        actions: 'الإجراءات',
        edit: 'تعديل',
        delete: 'حذف',
        save: 'حفظ',
        cancel: 'إلغاء',
        approve: 'موافقة',
        reject: 'رفض',
        role: 'الدور',
        user: 'مستخدم',
        administrator: 'مشرف',
        changePassword: 'تغيير كلمة المرور',
        newPassword: 'كلمة المرور الجديدة',
        confirmDeleteUser: 'هل أنت متأكد من حذف هذا المستخدم؟',
        confirmDeleteServer: 'هل أنت متأكد من حذف هذا الخادم؟',
        accessDenied: 'تم رفض الوصول',
        loginError: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
        registerError: 'فشل التسجيل',
        serverError: 'خطأ في الخادم',
        loading: 'جارٍ التحميل...',
        noServers: 'لا توجد خوادم متاحة',
        noUsers: 'لا يوجد مستخدمون متاحون',
        editLayout: 'تعديل التخطيط',
        saveLayout: 'حفظ التخطيط',
        addWidget: 'إضافة أداة',
        widgetTitle: 'عنوان الأداة',
        widgetUrl: 'رابط الأداة',
        content: 'المحتوى',
        widgetDescription: 'الوصف',
        widgetType: 'النوع',
        youtube: 'فيديو يوتيوب',
        spotify: 'مشغل سبوتيفاي',
        app: 'رابط تطبيق',
        container: 'حاوية',
        image: 'صورة',
        text: 'محتوى نصي',
        clock: 'ساعة رقمية',
        calendar: 'تقويم',
        stats: 'إحصائيات',
        weather: 'الطقس',
        news: 'أخبار',
        notifications: 'إشعارات',
        lightTheme: 'المظهر الفاتح',
        darkTheme: 'المظهر الداكن',
        toggleTheme: 'تبديل المظهر',
        customization: 'تخصيص',
        backgroundColor: 'لون الخلفية',
        iconSize: 'حجم الأيقونة',
        layoutMode: 'وضع التخطيط',
        widgets: 'الأدوات',
        users: 'المستخدمون',
        summaryDashboard: 'الملخص',
        adminDashboard: 'لوحة المشرف',
        widgetsPageSubtitle: 'تصفح وافتح الأدوات من لوحة التحكم الخاصة بك.',
        usersPageSubtitle: 'عرض المستخدمين المسجلين وحالات الحساب.',
        dragResizeHint: 'اسحب وقم بتغيير حجم الأدوات أثناء تمكين وضع التحرير.',
        noDescription: 'لا يوجد وصف متاح.',
        openWidget: 'افتح الأداة',
        createdAt: 'تاريخ الإنشاء',
        noWidgets: 'لا توجد أدوات متاحة.',
        editMenu: 'تعديل القائمة',
        saveMenu: 'حفظ القائمة',
        addMenuItem: 'إضافة عنصر قائمة',
        editMenuItem: 'تعديل عنصر القائمة',
        label: 'التسمية',
        enterLabel: 'أدخل التسمية',
        addSection: 'إضافة قسم',
        editSection: 'تعديل القسم',
        sectionType: 'نوع القسم',
        enterContent: 'أدخل المحتوى',
        enterTitle: 'أدخل العنوان',
        enterDescription: 'أدخل الوصف',
        editWidget: 'تعديل الأداة',
        confirmDelete: 'هل أنت متأكد من حذف هذا العنصر؟',
        addItem: 'إضافة عنصر',
        itemType: 'نوع العنصر',
        addTo: 'إضافة إلى',
        sections: 'الأقسام',
        icons: 'الأيقونات',
        editItem: 'تعديل العنصر'
    }
};

export default translations;